import { render, staticRenderFns } from "./AllowanceConfigModal.vue?vue&type=template&id=3abb7a48"
import script from "./AllowanceConfigModal.vue?vue&type=script&lang=js"
export * from "./AllowanceConfigModal.vue?vue&type=script&lang=js"
import style0 from "./AllowanceConfigModal.vue?vue&type=style&index=0&id=3abb7a48&prod&lang=scss"
import style1 from "./AllowanceConfigModal.vue?vue&type=style&index=1&id=3abb7a48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports